module.exports = __webpack_public_path__ + "img/site-3.06144150.jpg";